"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sha_js_1 = require("sha.js");

function hashSha256(input) {
  var hashFunction = new sha_js_1.sha256();
  return hashFunction.update(input).digest();
}

exports.hashSha256 = hashSha256;

function hashSha256Async(input) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var isSubtleCryptoAvailable, buffer, hash, nodeCrypto;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            isSubtleCryptoAvailable = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined';

            if (!isSubtleCryptoAvailable) {
              _context.next = 10;
              break;
            }

            // Use the W3C Web Crypto API if available (running in a web browser).
            buffer = typeof input === 'string' ? Buffer.from(input) : input;
            _context.next = 6;
            return crypto.subtle.digest('SHA-256', buffer);

          case 6:
            hash = _context.sent;
            return _context.abrupt("return", Buffer.from(hash));

          case 10:
            // Otherwise try loading the Node.js `crypto` module (running in Node.js, or an older browser with a polyfill).
            nodeCrypto = require('crypto');

            if (nodeCrypto.createHash) {
              _context.next = 13;
              break;
            }

            throw new Error('`crypto` module does not contain `createHash`');

          case 13:
            return _context.abrupt("return", Promise.resolve(nodeCrypto.createHash('sha256').update(input).digest()));

          case 14:
            _context.next = 21;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
            console.log('Crypto lib not found. Neither the global `crypto.subtle` Web Crypto API, ' + 'nor the or the Node.js `require("crypto").createHash` module is available. ' + 'Falling back to JS implementation.');
            return _context.abrupt("return", Promise.resolve(hashSha256(input)));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));
}

exports.hashSha256Async = hashSha256Async;